import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd327438"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nongfu-button-wrap" }
const _hoisted_2 = {
  key: 1,
  class: "unappeal-tips"
}

import { Button } from 'vant'
import { useRouter } from 'vue-router'
import { commonErrorHandle } from '@/utils/error-handle'
import { ApplyTechnicalSupport } from '@/apis/malfunction-repair'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair'
import { showConfirmModal, showToastLoading, showToastSuccess } from '@/utils/tools'
import { withDefaults, computed, CSSProperties } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'analysis-apply-button',
  props: {
    guid: { default: '' },
    from: { default: 'service-detail' },
    showMarginLeft: { type: Boolean, default: false },
    isSystemAnalysis: { type: Boolean, default: false },
    isTechnicalSupport: { type: Boolean, default: false },
    canAppeal: { type: Boolean, default: false },
    isPlant: { type: Boolean, default: false }
  },
  emits: ['update'],
  setup(__props: any, { emit: emits }) {

const props = __props as { guid: string, from: string, showMarginLeft: boolean, isSystemAnalysis: boolean, isTechnicalSupport: boolean, canAppeal: boolean, isPlant: boolean };



const $router = useRouter()
const { addServiceOrderKeepAlive, addOrderDutyResultItemKeepAlive } = useMalfunctionRepairStore()
const buttonText = computed(() => {
  return props.isSystemAnalysis ? '申请技术支持' : '有异议，进行申诉'
})
const buttonStyle = computed(() => {
  const result: CSSProperties = {}
  const isFromRepairDetail = props.from === 'service-detail'
  if (isFromRepairDetail) {
    result.height = '36px'
  }
  if (props.showMarginLeft) {
    result.marginLeft = `${isFromRepairDetail ? 12 : 16}px`
  }
  if (!props.isSystemAnalysis) {
    result.width = '170px'
  }
  return result
})
function clickHandle() {
  if (props.isSystemAnalysis) {
    // 申请技术支持
    void applyTechnicalSupportHandle()
  } else {
    if (props.from === 'service-detail') {
      addServiceOrderKeepAlive()
    } else if (props.from === 'duty-result') {
      addOrderDutyResultItemKeepAlive()
    }
    $router.push({
      name: 'malfunction-repair-duty-result-appeal',
      query: {
        guid: props.guid,
        isPlant: String(props.isPlant)
      },
    })
  }
}

async function applyTechnicalSupportHandle() {
  try {
    await showConfirmModal({
      title: '技术支持',
      message: '是否确认申请技术支持？',
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
    })
  } catch (error) {
    return
  }
  showToastLoading()
  try {
    await ApplyTechnicalSupport(props.guid)
    showToastSuccess('申请成功')
    emits('update')
  } catch (error) {
    commonErrorHandle(error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.canAppeal)
      ? (_openBlock(), _createBlock(_unref(Button), {
          key: 0,
          round: "",
          class: "apply-button xa-vant-button",
          onClick: clickHandle,
          style: _normalizeStyle(_unref(buttonStyle))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(buttonText)), 1)
          ]),
          _: 1
        }, 8, ["style"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, "申诉次数已达上限！"))
  ]))
}
}

})